import { AbsoluteCenter, Box, Flex, Heading, Skeleton, Spinner, Stack, Text } from "@chakra-ui/react";
import { formatPrice } from "../../../../utils";
import { useLimitSuccessFlow } from "./hooks";
import { usePersistStore } from "../../../../store/persistStore.ts";
import { EJWTStatus, validateJWT } from "../../../../utils";
import { redirect } from "react-router-dom";
import { RoutesMap } from "../../../../routes.tsx";
import { limitsQueryConfig, queryClient } from "../../../../api";

export function LimitSuccess() {
  const flow = useLimitSuccessFlow();

  return (
    <Box position="relative" h="calc(100vh - 84px * 2)">
      <AbsoluteCenter axis="both">
        <Stack spacing={9} minW="300px">
          <div>
            <Heading textAlign="center">
              Вам одобрен лимит
              <br />
              <Skeleton isLoaded={flow.isAmountReady} display="inline-block">
                {formatPrice(flow.approvedAmount, 0)}
              </Skeleton>
            </Heading>
          </div>
          <Text size="sm" align="center">
            Для подписания договора перейдите в приложение Wildberries
          </Text>
          <Flex alignItems="center" justifyContent="center" mt={10} mb={10}>
            <Spinner variant="white" />
          </Flex>
          <Text size="sm" align="center">
            После подписания договора вы сможете зайти в личный кабинет
          </Text>
        </Stack>
      </AbsoluteCenter>
    </Box>
  );
}

LimitSuccess.loader = async () => {
  const { jwt } = usePersistStore.getState();
  if (!jwt || validateJWT(jwt) === EJWTStatus.Invalid) {
    return redirect(RoutesMap.login.index);
  }

  try {
    await queryClient.fetchQuery({
      ...limitsQueryConfig(),
      staleTime: 0,
    });
  } catch (_e) {
    // Includes 401 / NetworkError etc.
    return redirect(RoutesMap.login.index);
  }

  return null;
};
